import React, { useState } from "react";
import { Box } from "@mui/material";

function SelectableBox({ label }: { label: string }) {
  const [selected, setSelected] = useState<boolean>(false);

  const handleBoxClick = () => {
    setSelected(!selected);
  };

  return (
    <Box
      p={1}
      border={1}
      borderRadius={2}
      display="flex"
      justifyContent="center"
      bgcolor={selected ? "primary.main" : "background.paper"}
      color={selected ? "primary.contrastText" : "text.primary"}
      onClick={handleBoxClick}
      sx={{ cursor: "pointer" }}
    >
      {label}
    </Box>
  );
}

export default SelectableBox;
